export default __webpack_public_path__ + "static/media/ham4.a32ef1aa.png";